import { authLogout } from 'actions';
import { AuthTokens, fetchAuthSession } from 'aws-amplify/auth';
import { store } from 'index';
import { CognitoTokens } from 'types/auth';
import { errorAlert } from 'utils/alert';

export const currentSession = async (): Promise<CognitoTokens> => {
  try {
    const authTokens = (await fetchAuthSession()).tokens ?? ({} as AuthTokens);

    // return authTokens;
    return {
      idToken: authTokens.idToken?.toString()!,
      accessToken: authTokens.accessToken.toString()
    };
  } catch (error) {
    // log user out when no tokens returned
    store.dispatch(authLogout());
    errorAlert('Not authorized. Please login again.');
    throw error;
  }
};
